import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ESIGN_DATA_SITE_ID, ESIGN_SCRIPT_URL, ESIGN_REDIRECTION_TOKEN } from "utilities/Constant";

interface ElectronicSignatureProps {
  loanAccessToken?: string;
  packageId?: string;
}

const ElectronicSignature: React.FC<ElectronicSignatureProps> = ({ loanAccessToken, packageId }) => {
  const eSignRedirectionToken = localStorage.getItem(ESIGN_REDIRECTION_TOKEN);
  const navigate = useNavigate();
  useEffect(() => {
    if (eSignRedirectionToken) {
      const script = document.createElement("script");
      script.src = ESIGN_SCRIPT_URL;
      script.async = true;
      document.body.appendChild(script);

      return () => {
        script.remove();
      };
    } else {
      navigate("/post-auth", { replace: true });
    }
  }, [eSignRedirectionToken]);

  return (
    <div
      className="em-widget"
      data-testid="em-widget"
      data-width="100%"
      data-height="800px"
      data-min-height="800px"
      data-site-id={ESIGN_DATA_SITE_ID}
      data-config={`{"authentication":"","token":"${loanAccessToken ?? ""}","packageId":"${packageId ?? ""}","externalLoginWindow":"true"}`}
      data-name="ecc-borrower-portal"
      data-aria-label="Borrower Portal"
    ></div>
  );
};

export default ElectronicSignature;
